
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Im Jahr 1979 postulierten Forscher, dass bestimmte Botenstoffe des
Trigeminusnervs Migräne verursachen können. Einer dieser Stoffe, abgekürzt CGRP,
weitet nur die kleinsten Blutgefässe und vermittelt Schmerzsignale, zum Beispiel
aus den Hirnhäuten. Neue Antikörper blockieren die schmerzauslösende Wirkung von
CGRP. Die Wirkstoffe heissen Erenumab, Galcanezumab oder Fremanezumab und sind
in der Schweiz bereits zugelassen. In Studien reduzierten diese Spritzen die
Migränetage um 3,2 bis 6,6 Tage pro Monat. Zum Vergleich: Eine Placebobehandlung
ersparte den Patienten 0,2 bis 4,2 Migränetage. Einzelne Patienten profitieren
sehr von dieser Behandlung: Sie haben zum Beispiel statt 22 Migränetagen pro
Monat gar keinen mehr – trotzdem gibt es auch Kritik an diesen neuen
Medikamenten. Wirkstoffe, die auf «-gepant» enden, setzen ebenfalls bei CGRP an,
sind aber zum Einnehmen. Sie sind noch in der Pipeline oder knapp vor der vom
Hersteller erwarteten Zulassung für die USA. Auch der neue Wirkstoff Lasmiditan,
der im akuten Migräneanfall helfen soll, ist in der Schweiz bisher noch nicht
zugelassen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;